import { GrehepisemaSize } from '../../gregorio-chant-svg-renderer/episemas/enums';
import { GregorioType } from '../enums/GregorioType';
import { GregorioVPosition } from '../enums/GregorioVPosition';
import { InterpreterContext } from '../parsers/compounded/CompoundedInterpreter';
import { GregorioNoteElement, HEPISEMA } from '../structures/GregorioNoteElement';


function apply_auto_h_episema(note: GregorioNoteElement, size: GrehepisemaSize, disable_bridge: boolean): void {
  if (note.h_episema_above === HEPISEMA.NONE && note.h_episema_below === HEPISEMA.NONE) {
    set_h_episema_above(note, HEPISEMA.AUTO, size, !disable_bridge);
    set_h_episema_below(note, HEPISEMA.AUTO, size, !disable_bridge);
  } else if (note.h_episema_above === HEPISEMA.AUTO && note.h_episema_below === HEPISEMA.AUTO) {
    note.h_episema_above = HEPISEMA.FORCED;
    set_h_episema_below(note, HEPISEMA.FORCED, size, !disable_bridge);
  } else {
    if (note.h_episema_above !== HEPISEMA.FORCED) {
      set_h_episema_above(note, HEPISEMA.FORCED, size, !disable_bridge);
    }
    if (note.h_episema_below !== HEPISEMA.FORCED) {
      set_h_episema_below(note, HEPISEMA.FORCED, size, !disable_bridge);
    }
  }
}

function gregorio_position_h_episema_below(note: GregorioNoteElement, height: number, connect: boolean): void {
  if (!note || (note.type !== GregorioType.NOTE && note.type !== GregorioType.BAR)) {
    // throw new Error('Assertion failed: note is not defined or its type is not NOTE or BAR');
    return;
  }
  note.h_episema_below = height;
  note.h_episema_below_connect = connect;
}

function set_h_episema_below(note: GregorioNoteElement, height: number, size: GrehepisemaSize, connect: boolean): void {
  gregorio_position_h_episema_below(note, height, connect);
  note.h_episema_below_size = size;
}

function gregorio_position_h_episema_above(note: GregorioNoteElement, height: number, connect: boolean): void {
  if (!note || (note.type !== GregorioType.NOTE && note.type !== GregorioType.BAR)) {
    // throw new Error('Assertion failed: note is not defined or its type is not NOTE or BAR');
    return;
  }
  note.h_episema_above = height;
  note.h_episema_above_connect = connect;
}

function set_h_episema_above(note: GregorioNoteElement, height: number, size: GrehepisemaSize, connect: boolean): void {
  gregorio_position_h_episema_above(note, height, connect);
  note.h_episema_above_size = size;
}

function gregorio_activate_isolated_h_episema(notes: GregorioNoteElement[], note_i: number,
  size: GrehepisemaSize, disable_bridge: boolean, n: number): void {
  const note = notes[note_i];
  if (!note) {
    console.error('gregorio_activate_isolated_h_episema: note is not defined');
    return;
  }
  if (note.type !== GregorioType.NOTE) {
    console.error(`isolated horizontal episema after something that is not a note, ignored ${n} times`);
    return;
  }

  if (notes.length - 1 < n) {
    console.error('found more horizontal episema than notes able to be under');
    return;
  }

  apply_auto_h_episema(notes[notes.length - n - 1], size, disable_bridge);
}

export function gregorio_add_h_episema(notes: GregorioNoteElement[], note_i: number,
  size: GrehepisemaSize, vposition: GregorioVPosition, disable_bridge: boolean,
  interpreter_context: InterpreterContext): void {
  const note = notes[note_i];
  if (!note || (note.type !== GregorioType.NOTE && note.type !== GregorioType.BAR)) {
    // throw new Error('trying to add a horizontal episema on something that is not a note');
    return;
  }

  if (vposition && interpreter_context.nbof_isolated_episema) {
    // eslint-disable-next-line max-len
    // throw new Error('trying to add a forced horizontal episema on a note which already has an automatic horizontal episema');
    return;
  }

  if (vposition || !interpreter_context.nbof_isolated_episema) {
    switch (vposition) {
      case GregorioVPosition.ABOVE:
        set_h_episema_above(note, HEPISEMA.FORCED, size, !disable_bridge);
        break;

      case GregorioVPosition.BELOW:
        set_h_episema_below(note, HEPISEMA.FORCED, size, !disable_bridge);
        break;

      default: /* VPOS_AUTO */
        apply_auto_h_episema(note, size, disable_bridge);
        interpreter_context.nbof_isolated_episema = 1;
        break;
    }
  } else {
    gregorio_activate_isolated_h_episema(notes, note_i,
      size, disable_bridge, interpreter_context.nbof_isolated_episema++);
  }
}
